<template>
  <v-layout column>
    <v-layout align-center class="ml-1">
      <div class="mr-2">{{ followUpQuestion.options.length + 1 }}.</div>
      <v-text-field
        v-model="newFollowUpOption"
        hide-details
        solo
        :placeholder="
          isMultipleOptions
            ? 'New Option Name'
            : 'Name of the document to request'
        "
        class="default-input mr-2"
      />
      <sx-button-group>
        <div @click="addNewOption">
          <sx-button
            :is-disabled="isMultipleOptions ? false : disableInput"
            size="small"
            type="secondary"
          >
            {{ isMultipleOptions ? 'Add New Option' : 'Add Document Option' }}
          </sx-button>
        </div>
      </sx-button-group>
    </v-layout>
    <div v-if="isStateHelperVisible" class="mt-3">
      Add every US state &middot;
      <a @click="onAddStateOptionsAbbr">Abbreviated (<em>AL</em>)</a> &middot;
      <a @click="onAddStateOptionsFull">Full Name (<em>Alaska</em>)</a>
    </div>
    <div v-if="isCountryHelperVisible" class="mt-3">
      Add every country &middot;
      <a @click="onAddCountryOptions">Full Name (<em>United States</em>)</a>
    </div>
    <div v-if="isCurrencyHelperVisible" class="mt-3">
      Add every currency &middot;
      <a @click="onAddCurrencyOptionsWithCodes"
        >ISO 4217 With Codes (<em>US Dollar (USD)</em>)</a
      >
      &middot;
      <a @click="onAddCurrencyOptionsNames"
        >ISO 4217 Names Only (<em>US Dollar</em>)</a
      >
      &middot;
      <a @click="onAddUSTreasuryCurrencyOptions"
        >US Treasury Foreign Currencies (<em>France-Euro</em>)</a
      >
    </div>
  </v-layout>
</template>

<script>
import SxButton from '@/components/sx/SxButton';
import SxButtonGroup from '@/components/sx/SxButtonGroup';

export default {
  name: 'NewOptionForm',
  components: {
    SxButton,
    SxButtonGroup,
  },
  props: {
    followUpQuestion: {
      type: Object,
      required: true,
    },
    add: {
      type: Function,
      required: true,
    },
    // NOTE @chris Passing 2 separate functions only because I can't seem to make emit pass both attributes.
    // https://github.com/Soraban/soraban-ui/pull/2163#discussion_r1379292100
    addStates: {
      type: Function,
      default: () => null,
      required: false,
    },
    addStatesAbbr: {
      type: Function,
      default: () => null,
      required: false,
    },
    addCountries: {
      type: Function,
      default: () => {},
      required: false,
    },
    addCurrencies: {
      type: Function,
      default: () => {},
      required: false,
    },
    addCurrenciesWithCodes: {
      type: Function,
      default: () => {},
      required: false,
    },
  },
  computed: {
    isStateHelperVisible() {
      const helpStrings = ['/help', '/states', 'AL', 'Alaska'];

      return (
        helpStrings.includes(this.newFollowUpOption) &&
        this.addStates &&
        this.addStatesAbbr
      );
    },
    isCountryHelperVisible() {
      const helpStrings = ['/help', '/countries', 'US', 'United States'];

      return (
        helpStrings.includes(this.newFollowUpOption) &&
        this.addCountries &&
        typeof this.addCountries === 'function'
      );
    },
    isCurrencyHelperVisible() {
      const helpStrings = ['/help', '/currencies', 'USD', 'US Dollar'];

      return (
        helpStrings.includes(this.newFollowUpOption) &&
        this.addCurrencies &&
        this.addCurrenciesWithCodes &&
        typeof this.addCurrencies === 'function' &&
        typeof this.addCurrenciesWithCodes === 'function'
      );
    },
    isMultipleOptions() {
      return (
        this.followUpQuestion.question_type === 'select' ||
        this.followUpQuestion.question_type === 'multiple'
      );
    },
    disableInput() {
      return (
        this.newFollowUpOption &&
        (this.newFollowUpOption.includes('/') ||
          this.newFollowUpOption.includes('.'))
      );
    },
  },
  data() {
    return {
      newFollowUpOption: '',
    };
  },
  methods: {
    addNewOption() {
      this.$emit('add', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
    onAddStateOptionsFull() {
      this.$emit('addStates', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
    onAddStateOptionsAbbr() {
      this.$emit('addStatesAbbr', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
    onAddCountryOptions() {
      this.$emit('addCountries', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
    onAddCurrencyOptionsWithCodes() {
      this.$emit('addCurrenciesWithCodes', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
    onAddCurrencyOptionsNames() {
      this.$emit('addCurrencies', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
    onAddUSTreasuryCurrencyOptions() {
      this.$emit('addUSTreasuryCurrencies', this.newFollowUpOption);
      this.newFollowUpOption = '';
    },
  },
};
</script>
